import { COLOR } from '@src/styles/color';

export const CATEGORIES = [
  { value: 'review', label: 'Review phim', labelEn: 'Review movie' },
  { value: 'news', label: 'Tin tức', labelEn: 'News' },
  { value: 'advertise', label: 'Quảng cáo', labelEn: 'Advertise' },
  { value: 'book', label: 'Sách nói', labelEn: 'Book' },
  { value: 'education', label: 'Đào tạo', labelEn: 'Education' },
  { value: 'story', label: 'Đọc truyện', labelEn: 'Story' },
  { value: 'callcenter', label: 'Tổng đài', labelEn: 'Call center' },
  { value: 'children', label: 'Trẻ em', labelEn: 'Children' },
];

export const VOICE_CATEGORY = { EDUCATION: 'education' };

export const CATEGORY_VOICE_CLONING_ORDER = [
  'review',
  'news',
  'story',
  'advertise',
  'book',
  'education',
  'callcenter',
  'children',
];

export const AUDIO_TYPE = { WAV: 'wav' };

export const WHITESPACE_REGEX = /\s+/g;

export const TIME_PER_SYLLABLE = 500; // ms

export const MIN_TIME_PER_SENTENCE = 10000; // ms

export const MIN_AUDIO_DURATION = 2000; // ms

export const MILLISECONDS_PER_SECOND = 1000; // ms

export const RECORD_INTERVAL = 250; // ms

export const RECURSIVE_TIMEOUT = 100; // ms

export const PUNCTUATION_REGEX = /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]$/;

export const VOICE_LOCALES = {
  NORTHERN: 'northern',
  CENTRAL: 'central',
  SOUTHERN: 'southern',
};

export const GENDER = [
  { value: 'male', label: 'male' },
  { value: 'female', label: 'female' },
];

export const AUDIO_STATUS = {
  FAILED: 'failed',
  IMPROVEMENT_NEEDED: 'improvement_needed',
  PASSED: 'passed',
  REJECTED: 'rejected',
  APPROVED: 'approved',
};

export const NEW_AUDIO_STATUS = {
  FAILED: 'failed',
  PENDING: 'pending',
  PASSED: 'passed',
  GOOD: 'good',
};

export const AUDIO_STATUSES = [
  { value: 'allSentence', label: 'allSentence' },
  { value: AUDIO_STATUS.PASSED, label: 'passedSentence' },
  {
    value: AUDIO_STATUS.IMPROVEMENT_NEEDED,
    label: 'improvementNeededSentence',
  },
  { value: AUDIO_STATUS.FAILED, label: 'failedSentence' },
];

export const NEW_AUDIO_STATUSES = [
  { value: 'allSentence', label: 'allSentence' },
  { value: AUDIO_STATUS.PASSED, label: 'passedSentence' },
  { value: AUDIO_STATUS.FAILED, label: 'failedSentence' },
];

export const VOICE_STATUS = {
  RECORDING: 'recording',
  REJECTED: 'rejected',
  WAITING_RECEIVED: 'waiting-received',
  REVIEWING: 'reviewing',
  TRAINING: 'training',
  TRAINED: 'trained',
  READY: 'ready',
  USING: 'using',
  FAILED: 'failed',
  SUSPENDED: 'suspended',
  PRIVATE: 'private',
  PUBLIC: 'public',
};

export const VOICE_PROCESSING = [
  VOICE_STATUS.RECORDING, // dang thu am
  VOICE_STATUS.WAITING_RECEIVED, // cho tiep nhan
  VOICE_STATUS.REVIEWING, // dang kiem tra
  VOICE_STATUS.TRAINING, // dang huan luyen
  VOICE_STATUS.TRAINED, // da huan luyen
  VOICE_STATUS.REJECTED, // chua dat
];

export const VOICE_COMPLETED = [
  VOICE_STATUS.READY, // san sang su dung
  VOICE_STATUS.USING, // dang su dung
  VOICE_STATUS.PRIVATE,
  VOICE_STATUS.PUBLIC,
];

export const VOICE_CAN_USE = [
  VOICE_STATUS.PRIVATE,
  VOICE_STATUS.PUBLIC,
  VOICE_STATUS.USING,
];

export const VOICE_NOT_USED = [
  VOICE_STATUS.FAILED, // khong thanh cong
  VOICE_STATUS.SUSPENDED, // dinh chi
];

export const REASON_VOICE_STATUS = [
  VOICE_STATUS.REJECTED,
  VOICE_STATUS.FAILED,
  VOICE_STATUS.SUSPENDED,
];

export const SUB_STATUS = {
  PASSED: 'passed',
  FAILED: 'failed',
  PENDING: 'pending',
  PROCESSING: 'processing',
  ERROR: 'error',
  PRIVATE: 'private',
  PUBLIC: 'public',

  WAITING_FOR_PUBLIC: 'waiting-for-public', // @deprecated use WAITING_FOR_APPROVAL
  REJECTED_FOR_PUBLIC: 'rejected-for-public', //  @deprecated use REJECTED
  WAITING_FOR_COMMUNITY_REMOVAL: 'waiting-for-community-removal', // @deprecated use WAITING_FOR_REMOVAL

  WAITING_FOR_APPROVAL: 'waiting-for-approval',
  REJECTED: 'rejected',
  WAITING_FOR_REMOVAL: 'waiting-for-removal',

  EMPTY: '',
};

export const VOICE_STATUSES = [
  { value: '', label: 'all' },
  { value: VOICE_STATUS.RECORDING, label: 'recording' },
  { value: VOICE_STATUS.REJECTED, label: 'reject' },
  { value: VOICE_STATUS.WAITING_RECEIVED, label: 'waitingReceived' },
  { value: VOICE_STATUS.REVIEWING, label: 'reviewing' },
  { value: VOICE_STATUS.TRAINING, label: 'training' },
  { value: VOICE_STATUS.TRAINED, label: 'trained' },
  { value: VOICE_STATUS.READY, label: 'readyUsing' },
  { value: VOICE_STATUS.USING, label: 'using' },
  { value: VOICE_STATUS.FAILED, label: 'unsuccess' },
  { value: VOICE_STATUS.SUSPENDED, label: 'suspended' },
  { value: VOICE_STATUS.PRIVATE, label: 'private' },
  { value: VOICE_STATUS.PUBLIC, label: 'public' },
];

export const VOICE_STATUS_COLORS = {
  [VOICE_STATUS.RECORDING]: 'dark',
  [VOICE_STATUS.WAITING_RECEIVED]: 'info',
  [VOICE_STATUS.REVIEWING]: 'info',
  [VOICE_STATUS.TRAINING]: 'info',
  [VOICE_STATUS.TRAINED]: 'info',
  [VOICE_STATUS.REJECTED]: 'error',
  [VOICE_STATUS.READY]: 'success',
  [VOICE_STATUS.USING]: 'success',
  [VOICE_STATUS.PRIVATE]: 'success',
  [VOICE_STATUS.PUBLIC]: 'success',
  [VOICE_STATUS.FAILED]: 'error',
  [VOICE_STATUS.SUSPENDED]: 'error',
  [VOICE_STATUS.PRIVATE]: 'success',
  [VOICE_STATUS.PUBLIC]: 'success',
};

export const USERNAME_EXISTS = 4003;

export const LIMIT_CLONED_VOICE = 4021;

export const MAX_LENGTH_VOICE_NAME = 25;

export const MIN_LENGTH_USERNAME = 5;

export const MAX_LENGTH_USERNAME = 25;

export const MAXIMUM_NUMBER_OF_ACTIVE_VOICES = 3;

export const MINIMUM_PERCENT_PASSED_QUALITY_OF_AUDIO = 0.8;

export const TIME_EXPIRE_QR_VOICE_CLONING = 1000 * 60 * 5; // 5 minutes

export const ORIGINAL_VOICE = 'originalVoice';

export const CLONE_VOICE = 'cloneVoice';

export const INSTANT_VOICE_CLONE = 'instantVoiceClone';

export const PRO_VOICE_CLONE = 'proVoiceClone';

export const VOICE_CLONE_TYPE = {
  ZERO_SHOT: 'zero-shot',
  FINETUNE_SCRIPTS_RECORDING: 'finetune-scripts-recording',
  FINETUNE_LONG_AUDIO: 'finetune-long-audio',
};

export const VOICE_PROCESSING_STATUS = {
  PROCESSING: 'PROCESSING',
  FAILURE: 'FAIL',
  SUCCESS: 'SUCCESS',
};

export const VOICE_PROCESSING_INTERVAL = 10 * 1000;

export const VOICE_NAME_REGEX =
  /^[a-zA-Z0-9ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝÝỶỸửữựỳýỵỷỹ\s]+$/;

export const NEW_VOICE_SUB_STATUSES = [
  {
    value: SUB_STATUS.WAITING_FOR_APPROVAL,
    label: 'waitingForApproval',
  },
  {
    value: SUB_STATUS.REJECTED,
    label: 'requestRejected',
  },
  {
    value: SUB_STATUS.WAITING_FOR_REMOVAL,
    label: 'waitingForCommunityRemoval',
  },
];

export const SUB_STATUS_COLORS = {
  [SUB_STATUS.WAITING_FOR_APPROVAL]: 'info',
  [SUB_STATUS.REJECTED]: 'error',
  [SUB_STATUS.WAITING_FOR_REMOVAL]: 'info',
};

export const STEP_VOICE_DETAIL = {
  VOICE_DETAIL: 'VOICE_DETAIL',
  FORM_SHARE_AND_EARN: 'FORM_SHARE_AND_EARN',
};

export const SORT_TYPES = {
  RevenueDown: 'revenueDown',
  RevenueUp: 'revenueUp',
  NameAZ: 'nameAZ',
  NameZA: 'nameZA',
};

export const VOICE_REVENUE_TRANSACTION_STATUS = {
  INIT: 'INIT',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED',
  APPROVED: 'APPROVED',
  PAID: 'PAID',
};

export const VOICE_REVENUE_TRANSACTION_STATUS_COLORS = {
  [VOICE_REVENUE_TRANSACTION_STATUS.INIT]: COLOR.indigo.default,
  [VOICE_REVENUE_TRANSACTION_STATUS.PENDING]: COLOR.indigo.default,
  [VOICE_REVENUE_TRANSACTION_STATUS.PROCESSING]: COLOR.blueV2,
  [VOICE_REVENUE_TRANSACTION_STATUS.CANCELLED]: COLOR.functionalRed.default,
  [VOICE_REVENUE_TRANSACTION_STATUS.REJECTED]: COLOR.functionalRed.default,
  [VOICE_REVENUE_TRANSACTION_STATUS.APPROVED]: COLOR.greenV2.default,
  [VOICE_REVENUE_TRANSACTION_STATUS.PAID]: COLOR.greenV2.default,
};

export const VOICE_PROFILE_PAGE_STATUS = {
  DRAFT: 'draft',
  PUBLIC: 'public',
};

export const VOICE_CLONING_TYPE = {
  CREATE: 'create',
};

export const AGE_GROUP_VOICE_CLONING = {
  CHILD: 'child',
  TEEN: 'teen',
  YOUNG: 'young',
  MIDDLE_AGED: 'middle-aged',
  OLD: 'old',
};

export const VOICE_REVENUE_TRANSACTION_STATUS_BACKGROUND_COLORS = {
  [VOICE_REVENUE_TRANSACTION_STATUS.INIT]: COLOR.bluev2[8],
  [VOICE_REVENUE_TRANSACTION_STATUS.PENDING]: COLOR.bluev2[8],
  [VOICE_REVENUE_TRANSACTION_STATUS.PROCESSING]: COLOR.bluev2[8],
  [VOICE_REVENUE_TRANSACTION_STATUS.CANCELLED]: COLOR.functionalRed[8],
  [VOICE_REVENUE_TRANSACTION_STATUS.REJECTED]: COLOR.functionalRed[8],
  [VOICE_REVENUE_TRANSACTION_STATUS.APPROVED]: COLOR.greenV2[8],
  [VOICE_REVENUE_TRANSACTION_STATUS.PAID]: COLOR.greenV2[8],
};

export const VOICE_REVENUE_TRANSACTION_STATUS_TEXT_COLORS = {
  [VOICE_REVENUE_TRANSACTION_STATUS.INIT]: COLOR.blueV2,
  [VOICE_REVENUE_TRANSACTION_STATUS.PENDING]: COLOR.blueV2,
  [VOICE_REVENUE_TRANSACTION_STATUS.PROCESSING]: COLOR.blueV2,
  [VOICE_REVENUE_TRANSACTION_STATUS.CANCELLED]: COLOR.functionalRed.default,
  [VOICE_REVENUE_TRANSACTION_STATUS.REJECTED]: COLOR.functionalRed.default,
  [VOICE_REVENUE_TRANSACTION_STATUS.APPROVED]: COLOR.greenV2.default,
  [VOICE_REVENUE_TRANSACTION_STATUS.PAID]: COLOR.greenV2.default,
};

export const VOICE_STATUS_VERIFY_SPEAKER = {
  SUCCESS: 'success',
  FAILED: 'failed',
};

export const MAX_VOICE_CLONING_TO_FETCH = 200;
